import { encryptParams } from '@/utils'
import base from '@/utils/base'
import request from '@/utils/request'

export default {
	// 初始化
	init(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.DEFAULT_BASE_URL}/api/init`,
			method: 'post',
			data: params
		})
	},
	// 获取短信验证码
	smsCode(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.USER_BASE_URL}/api/user/sendCode`,
			method: 'post',
			data: params
		})
	},
	// 登录
	login(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.USER_BASE_URL}/api/user/login`,
			method: 'post',
			data: params
		})
	},
	// 实名认证
	verified(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.USER_BASE_URL}/api/user/idcard/add`,
			method: 'post',
			data: params
		})
	},
	// 支付初始化
	payInit(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.PAY_BASE_URL}/api/pay/init`,
			method: 'post',
			data: params
		})
	},
	// 下单
	payOrder(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.PAY_BASE_URL}/api/pay/order`,
			method: 'post',
			data: params
		})
	},
	// 查询订单状态
	orderStatus(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.PAY_BASE_URL}/api/pay/order/status`,
			method: 'post',
			data: params
		})
	},
	// 打点上报
	reportLog(data) {
    const params = { d: encryptParams(data) }
		return request({
			url: `${base.LOG_BASE_URL}/api/log`,
			method: 'post',
			data: params
		})
	}
}